import {
  type BehaviorMapEventHandler,
  type LngLat,
  type MapLocationRequest,
  Image,
  Map as BaseMap,
  MapListener,
} from '@yandex-delivery/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {tag2url} from '@yandex-delivery/utils'
import React, {memo, useCallback} from 'react'

import {useConfigContext} from '../../../../../../../../utils/contexts/ConfigContext'
import {getMapLocale} from '../../../../../../../../utils/getMapLocale'
import * as styles from './Map.classes'

/** Пропсы компонента Map */
type MapProps = {
  /** Коллбэк на изменение локации */
  onLocationChange: (coordinates: LngLat) => void
  location: MapLocationRequest
  children?: React.ReactNode
}

/** Тег иконки пина */
const ADDRESS_PIN_ICON = 'delivery_address_pin'

/**
 * Компонент с картой и пином посередине,
 * который отслеживает координаты текущего центра карты при смене позиции пользователем.
 */
export const Map = memo<MapProps>(function Map({location, onLocationChange, children}) {
  const i18n = useI18n()

  const {lang} = useConfigContext()

  const handleActionEnd = useCallback<BehaviorMapEventHandler>(
    ({location}) => {
      onLocationChange(location.center)
    },
    [onLocationChange],
  )

  const mapLocale = getMapLocale(lang)

  return (
    <div className={styles.map}>
      <BaseMap errorMessage={i18n('map_load_error')} lang={mapLocale} location={location}>
        <Image className={styles.pinIcon} height={72} src={tag2url(ADDRESS_PIN_ICON)} />
        <MapListener onActionEnd={handleActionEnd} />
        {children}
      </BaseMap>
    </div>
  )
})
